/**
 * @Des 新增/编辑 账户 弹出层
 * @Auth
 * @Date 2021/6/19
 */

/* HTML */
<template>
    <div v-if="dialogForm.dialogFormVisible">
    	<el-dialog :title="dialogForm.title"
	               :visible.sync="dialogForm.dialogFormVisible"
	               :close-on-click-modal="false"
	               :modal-append-to-body="false"
	               custom-class="form-dialog"
	               v-dialogDrag
	               class="dialog_title"
	               @close="handleDialogClose"
	    >

	        <el-form class="head-image-form" label-width="130px" ref="dialogRowForm" :rules="rules" :model="dialogRowForm">
	            <el-form-item class="row-items-3" label="组名" prop="groupId">
	                <div v-if="dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.groupName" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <TreeSelect :data="userGroups" :selectTree="groupSelectTree" @setSelectVal="setSelectVal" ref="treeSelect"/>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="姓名" prop="userName">
	                <div v-if="dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.userName" disabled class="rt-input"/>
	                </div>
	                <div v-else>
					    <el-input v-model="dialogRowForm.userName" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="性别" prop="sex">
	                <div v-if="dialogForm.optionType == optionType.edit || dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-select v-model="dialogRowForm.sex" disabled class="rt-input">
	                        <el-option
	                            v-for="item in sexOpts"
	                            :key="item.value"
	                            :label="item.label"
	                            :value="item.value">
	                        </el-option>
	                    </el-select>
	                </div>
	                <div v-else>
	                    <el-select v-model="dialogRowForm.sex" >
	                        <el-option
	                            v-for="item in sexOpts"
	                            :key="item.value"
	                            :label="item.label"
	                            :value="item.value">
	                        </el-option>
	                    </el-select>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="职务" prop="duty">
	                <div v-if="dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.duty" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-input v-model="dialogRowForm.duty" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="手机号" prop="phone">
	                <div v-if="dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-select class="phone-code-select rt-input" v-model="dialogRowForm.phoneCode" disabled >
	                        <el-option v-for="item in phoneCodeOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
	                    </el-select>
	                    <el-input class="phone-item-input rt-input" v-model="dialogRowForm.phone" disabled />
	                </div>
	                <div v-else>
	                    <el-select class="phone-code-select" v-model="dialogRowForm.phoneCode" >
	                        <el-option v-for="item in phoneCodeOpts" :key="item.value" :label="item.label" :value="item.value"></el-option>
	                    </el-select>
	                    <el-input class="phone-item-input" v-model="dialogRowForm.phone" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="身份证号（或编号）：" prop="idCard">
	            	<label slot="label"><div style="line-height: 26px;">身份证号</div><div style="line-height: 20px;">(或编号)</div></label>
	                <div v-if="dialogForm.optionType == optionType.edit || dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
	                    <el-input v-model="dialogRowForm.idCard" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-input v-model="dialogRowForm.idCard" clearable/>
	                </div>
	            </el-form-item>
	            <el-form-item class="row-items-3" label="绑定标签号(选择或刷卡)：" prop="tagId">
	                <label slot="label"><div style="line-height: 26px;">绑定标签号</div><div style="line-height: 20px;">(选择或刷卡)</div></label>
	                <div v-if="dialogForm.optionType == optionType.edit || dialogForm.tagIdDisabledFlag">
	                    <el-input v-model="dialogRowForm.tagId" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-select v-model="dialogRowForm.tagId" clearable filterable :filter-method="dataFilter" :clear-method="dataClear" @change="searchTagUser(dialogRowForm.tagId)" ref="rowFormTagId">
	                        <el-option
	                            v-for="item in unBoundTagIds"
	                            :key="item.did"
	                            :label="item.did + (item.outId ? '（ ' + item.outId + ' ）' : '')"
	                            :value="item.did">
	                        </el-option>
	                    </el-select>
	                </div>
	            </el-form-item>
				<el-form-item class="row-items-1" label="备注" prop="remarks">
	                <div v-if="dialogForm.optionType == optionType.binding || dialogForm.optionType == optionType.unbound">
					    <el-input type="textarea" v-model="dialogRowForm.remarks" disabled class="rt-input"/>
	                </div>
	                <div v-else>
	                    <el-input type="textarea" v-model="dialogRowForm.remarks" clearable/>
	                </div>
				</el-form-item>
				
				<el-form-item class="row-items-1" label="照片" prop="remarks">
	                <div class="image-form-item">
		                <div style="position: absolute;left: 0;top: 0;">
		                	<div :class="{'image-item-box': true, 'none-item': !dialogRowForm.portrait && false}">
			                    <img :src="extractImgData" alt="头像" />
			                    <span class="noImgItem el-icon-circle-plus-outline"></span>
			                </div>
		                </div>
		                <button type="button" class="image-item-title el-button-bg" @click="getCompetence()" v-if="!video.playFlag">打开摄像头</button>
		                <button type="button" class="image-item-title el-button-bg" @click="stopNavigator()" v-else>关闭摄像头</button>
		                <div :class="{'camara-pre-view': true, 'on': video.playFlag}">
		                    <div class="image-item-box" >
		                        <video id="videoCamera" :width="video.width" :height="video.height" autoplay></video>
		                        <canvas style="display:none;" id="canvasCamera" :width="video.width" :height="video.height" ></canvas>
		                    </div>
		                    <button type="button" class="image-item-title el-button-bg" @click="photograph()" style="position: absolute;bottom: 10px;left: 6px;">拍照</button>
		                </div>
		                <el-upload
		                    ref="uploadImg"
		                    accept="image/gif,image/jpeg,image/jpg,image/png"
		                    :auto-upload="false"
		                    :show-file-list="false"
		                    :before-upload="()=>{}"
		                    :on-success="()=>{}"
		                    :on-error="()=>{}"
		                    action="null"
		                    :headers="{}"
		                    :on-change="(file,fileList)=>{return changeFile(file,fileList, 1)}"
		                ><button type="button" class="image-item-title el-button-bg" style="width: 135px;">照片上传</button></el-upload>
		            </div>
				</el-form-item>
				
	            <el-form-item v-if="!$checkEmpty(dialogForm.submitButton)" class="row-items-1 btn-form-item-r" style="margin-bottom: 0;">
	                <el-button class="el-button-bg" type="primary" size="primary" @click="submitForm()">{{dialogForm.submitButton}}</el-button>
	            </el-form-item>
	        </el-form>
			
			<!-- scanCode -->
	        <ScanCode v-if="scanFilter.showFlag" ref="scanCode" :scanFilter="scanFilter" @callback="tagChange" @skipScan="skipScan" />
			
	        <!-- webSoket -->
	        <SubWebsoket v-if="GlobalVariable.OPEN_NFC && dialogForm.optionType != optionType.edit" ref="subWebsoket"
				:wsUrl="wsFilter.wsUrl"
				:wsKey="wsFilter.wsKey"
				:autoRecreatFlag="wsFilter.autoRecreatFlag"
				:wsOnopen="wsFilter.wsOnopen"
				:wsOnmessage="wsFilter.wsOnmessage"
				:winMessageFn="wsFilter.winMessageFn"
			/>
			<!-- NFCIDCardSub -->
	        <NFCIDCardSub v-if="GlobalVariable.OPEN_ID_CARD && !dialogForm.editFlag || dialogForm.editFlag == 'add'" ref="NFCIDCardSub"
				:time_fresh_nfc="NFCIDCardFilter.time_fresh_nfc"
				:dataNFCMsg="NFCIDCardFilter.dataNFCMsg"
			/>

	    </el-dialog>
    </div>
</template>

/* JS */
<script>
	// 公共变量
	import GlobalVariable from '@/global/global-variable'
	// 公共方法
    import GlobalFun from '@/global/global-function'
    // 交互 接口
    import ApiUser from '@/request/api-user'
    // 交互 接口
    import ApiOam from '@/request/api-oam'
    // 交互 接口
    import ApiGpsTag from '@/request/api-gps-tag'
    // 下拉树结构 组件
    import TreeSelect from '@/components/TreeSingleSelect.vue'
    // 校验 组件
    import {checkEmpty, validFormat, checkFormat} from '@/global/global-valid'
    // ws Api
    import ApiNfcWs from '@/request/api-nfc_ws'
    
    // 组件 webSoket
    import SubWebsoket from '@/components/SubWebsoket'
    // 组件 NFC IDCard
    import NFCIDCardSub from '@/components/NFCIDCardSub'
    // 组件 ScanCode
    import ScanCode from '@/components/ScanCode/ScanCode'

    export default {
        /**
         * @Des 组件名
         * @Auth
         * @Date 2021/6/19
         */
        name: 'UserDialog',
        /**
         * @Des 数据接收类型
         * @Auth
         * @Date 2021/6/19
         */
        props:{
            // 用户组信息集合
            userGroups: {
                type: Array,
                default: function (){
                    return [];
                }
            },
            // 默认展示状态
            visibleFlag: {
                type: Boolean,
                default: function (){
                    return false;
                }
            },
        },
        /**
         * @Des 组件引用
         * @Auth
         * @Date 2021/6/19
         */
        components: {
            // 选择树
            TreeSelect,
            // webSoket
            SubWebsoket,
            // 组件 NFC IDCard
            NFCIDCardSub,
            // 组件 ScanCode
            ScanCode,
        },
        /**
         * @Des 数据定义
         * @Auth
         * @Date 2021/6/19
         */
        data() {
            return{
                // 公共变量
                GlobalVariable,
                /**
                 * @Des option 摄像头属性
                 * @Auth zhangbin
                 * @Date 2021/6/30
                 * */
                video: {
                    // 视图 宽
                    width: 120,
                    // 视图 高
                    height: 120,
                    // 拍照图像
                    imgSrc: '',
                    // 画布 标签节点
                    thisCancas: null,
                    // 截图
                    thisContext: null,
                    // video 标签节点
                    thisVideo: null,
                    // 是否开启摄像头
                    playFlag: false,
                },
                // 未绑定的标签
                unBoundTagIds: [],
                // 未绑定的标签 Copy
                unBoundTagIdsCopy: [],
                /**
                 * @Des option集合 性别
                 * @Auth
                 * @Date 2021/6/29
                 */
                sexOpts: [
                	{label: '男', value: 1},
                	{label: '女', value: 2}
                ],
                /**
                 * @Des option集合 区号
                 * @Auth
                 * @Date 2021/6/29
                 */
                phoneCodeOpts: [
                	{label: '+86', value: 86}
                ],
                /**
                 * @Des 默认头像
                 * @Auth
                 * @Date 2021/7/2
                 */
                defaultIcons: {
                	'1': '/static/images/icon-user-1.png',
                	'2': '/static/images/icon_user_2.png',
                	iconData: ''
                },


                /**
	             * @Des webSoket参数
	             * @Auth
	             * @Date 2021/7/2
	             */
	            wsFilter: {
	            	// webSoket路径
		            wsUrl: ApiNfcWs.wsUrlNfc,
		            // webSoket key
		            wsKey: '_NFC',
		            // 自动重新连接
		            autoRecreatFlag: true,
		            // 连接已打开
		            wsOnopen: this.wsOnopen,
		            // 数据推送
		            wsOnmessage: this.wsOnmessage,
		            // 无 this.wsOnmessage 时，onmessage 监听回调 {方法名称}
		            winMessageFn: null
		            // this.onMessage 与 this.wsOnmessage 存一即可
	            },

                /**
	             * @Des NFCIDCard参数
	             * @Auth
	             * @Date 2021/7/3
	             */
                NFCIDCardFilter: {
                	// 休眠时间 毫秒
					time_fresh_nfc: (3 * 1000),
					// 身份证信息 回显
					dataNFCMsg: this.dataNFCIDCard,
                },
				
				/**
				 * @Des 扫码
				 * @Auth
				 * @Date
				 */
				scanFilter: {
					// 是否展示
					showFlag: true,
					// 是否展示 跳过
					skipScanFlag: false,
				},
				
                /**
                 * @Des 弹出层属性
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogForm: {
                    title: "刷卡绑定/解绑",
                    submitButton: '',
                    optionType: '',
                    dialogFormVisible: this.visibleFlag,
                    tagIdDisabledFlag: true,
                },
                optionType: {
                    add: 'add',
                    edit: 'edit',
                    binding: 'binding',
                    unbound: 'unbound'
                },
                /**
                 * @Des 修改表单
                 * @Auth
                 * @Date 2021/6/19
                 */
                dialogRowForm: {
                	// 当前用户
                	userId: '',
                	// row 下标
                    rowIndex: -1,
                    // 性别
                    sex: 1,
                    // 区号
                    phoneCode: 86,
                    // 手机号
                    phone: '',
                    // 姓名
                    userName: '',
                    // 职务
                    duty: '',
                    // 备注
                    remarks: '',
                    // 类型id
                    typeId: '',
                    // 组id
                    groupId: '',
                    // 组名
                    groupName: '',
                    // 身份证号
                    idCard: '',
                    // 头像
                    portrait: '',
                    // 标签id
                    tagId: '',
                },
                /**
                 * @Des 用户组树数据
                 * @Auth
                 * @Date 2021/6/4
                 */
                groupSelectTree:{
                    placeholder: '请选择组名',
                    keywordFilter: false,
                    showBox: false,
                    childBox: false,
                    parentBox: false,
                },

                /**
                 * @Des 弹窗规则
                 * @Auth
                 * @Date 2021/6/19
                 */
                rules: {
                    groupId: [
                        { required: true, message: '请选择类型下的组名', trigger: 'false' }
                    ],
                    userName: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    phone: [
                        {
                        	validator: (rule, value, callback) => {
	                            if (!checkEmpty(value) && !checkFormat(value, validFormat.phone)) {
	                            	new callback(new Error("请输入11位手机号"));
	                            } else {
	                                callback()
	                            }
	                        },
	                        trigger: "blur"
                        }
                    ],
                }// rules
            }
        },
		/** 
         * @Des doc加载完成后自动执行
         * @Auth  
         * @Date 
         */
        mounted() {
			
        },// mounted
        /**
         * @Des 方法定义
         * @Auth
         * @Date 2021/6/19
         */
        methods:{
            // 调用权限（打开摄像头功能）
            getCompetence() {
                var _this = this
                this.video.thisCancas = document.getElementById('canvasCamera')
                this.video.thisContext = this.video.thisCancas.getContext('2d')
                this.video.thisVideo = document.getElementById('videoCamera')
                // 旧版本浏览器可能根本不支持mediaDevices，我们首先设置一个空对象
                if (navigator.mediaDevices === undefined) {
                    navigator.mediaDevices = {}
                }
                // 一些浏览器实现了部分mediaDevices，我们不能只分配一个对象
                // 使用getUserMedia，因为它会覆盖现有的属性。
                // 这里，如果缺少getUserMedia属性，就添加它。
                if (navigator.mediaDevices.getUserMedia === undefined) {
                    navigator.mediaDevices.getUserMedia = function (constraints) {
                        // 首先获取现存的getUserMedia(如果存在)
                        var getUserMedia = navigator.webkitGetUserMedia || navigator.mozGetUserMedia || navigator.getUserMedia
                        // 有些浏览器不支持，会返回错误信息
                        // 保持接口一致
                        if (!getUserMedia) {
                            return Promise.reject(new Error('getUserMedia is not implemented in this browser'))
                        }
                        // 否则，使用Promise将调用包装到旧的navigator.getUserMedia
                        return new Promise(function (resolve, reject) {
                            getUserMedia.call(navigator, constraints, resolve, reject)
                        })
                    }
                }
                var constraints = { audio: false, video: { width: this.video.width, height: this.video.height, transform: 'scaleX(-1)' } }
                navigator.mediaDevices.getUserMedia(constraints).then(function (stream) {
                    // 旧的浏览器可能没有srcObject
                    if ('srcObject' in _this.video.thisVideo) {
                        _this.video.thisVideo.srcObject = stream
                    } else {
                        // 避免在新的浏览器中使用它，因为它正在被弃用。
                        _this.video.thisVideo.src = window.URL.createObjectURL(stream)
                    }
                    _this.video.thisVideo.onloadedmetadata = function (e) {
                        _this.video.thisVideo.play();

                        // 是否开启摄像头
                    	_this.video.playFlag = true;
                    }
                }).catch(err => {
                    // 是否开启摄像头
					_this.video.playFlag = false;

                    console.error(err)
                })
            },
            // 拍照
            photograph(){
                this.setImage();
            },
            // 绘制图片（拍照功能）
            setImage () {
                var _this = this
                // 点击，canvas画图
                _this.video.thisContext.drawImage(_this.video.thisVideo, 0, 0, _this.video.width, _this.video.height)
                // 获取图片base64链接
                var image = this.video.thisCancas.toDataURL('image/png')
                _this.video.imgSrc = image
                this.dialogRowForm.portrait = image;
            },
            // base64转文件
            dataURLtoFile (dataurl, filename) {
                var arr = dataurl.split(',')
                var mime = arr[0].match(/:(.*?);/)[1]
                var bstr = atob(arr[1])
                var n = bstr.length
                var u8arr = new Uint8Array(n)
                while (n--) {
                    u8arr[n] = bstr.charCodeAt(n)
                }
                return new File([u8arr], filename, { type: mime })
            },
            // 关闭摄像头
            stopNavigator () {
                if(this.video.playFlag){
                    this.video.thisVideo.srcObject.getTracks()[0].stop()
                    this.video.playFlag = false;
                }
            },

            /**
             * @Des 文件上传 change
             * @Auth
             * @Date 2021/7/2
             */
            changeFile(file,fileList) {
              	let _this = this;
              	// file 转换成 base64
              	GlobalFun.readFileImg(file.raw, data => {_this.dialogRowForm.portrait = data.src});
            },

            /*
	        // webSoket 数据推送   利用window监听
	        onMessage(e) {
	        	this.keyword = e.data;
	        	// 检索数据
	        	this.scanDeviceId();
	        },
	        */
	        // webSoket 数据推送   onmessage回调
	        wsOnmessage(e) {
	        	// 检索数据
	        	//this.scanDeviceId();

				// 检索标签是否未绑定
				let inArrFlag = false;
				this.unBoundTagIdsCopy.forEach((row, index) => {
					if (row.tagId == e.data) {
						inArrFlag = true;
					}
				});

				let msg = '请更换标签';
				// 绑定
				if (this.dialogForm.optionType == this.optionType.binding || this.dialogForm.optionType == this.optionType.add) {
					msg = '标签（'+ e.data +'）已绑定，<br><br>请更换标签或将标签解绑后重试。';
				}
				if (this.dialogForm.optionType == this.optionType.unbound) {
					msg = '标签（'+ e.data +'）未绑定，<br><br>请更换标签。';
				}

				if (inArrFlag) {
					// 标签id
					this.dialogRowForm.tagId = e.data;
					if (this.dialogForm.optionType == this.optionType.unbound) {
						// 查询人员信息
						this.searchTagUser(e.data);
					}
				} else {
					this.$message({
                        message: msg,
                        type: 'warning',
                        showClose: true,
                        dangerouslyUseHTMLString: true
                    });
				}
	        },

            /**
             * @Des 身份信息 回显
             * @Auth
             * @Date 2021/7/2
             */
            dataNFCIDCard (data) {
                    // 姓名
              this.dialogRowForm.userName = data.userName;
              // 性别
              this.dialogRowForm.sex = data.sex == '女' ? 2 : 1;
              // 身份证号
              this.dialogRowForm.idCard = data.idCard;
              // 头像
              this.dialogRowForm.portrait = data.Base64Photo;
            },
			
			/**
             * @Des 下拉框 清空
             * @Auth
             * @Date
             */
			dataClear() {
				setTimeout(() => {
					// 还原数据
					this.unBoundTagIds = Object.assign([], this.unBoundTagIdsCopy);
				});
			},
			/**
             * @Des 下拉框 搜索框输入
             * @Auth
             * @Date
             */
			dataFilter(val) {
				if (!this.$checkEmpty(this.timer_dataFilter)) {
					clearTimeout(this.timer_dataFilter);
					this.timer_dataFilter = null;
				}
				
				const tagId = this.dialogRowForm.tagId;
				if (val.length >= 16) {
					val = val.toUpperCase().substring(val.length - 16);
					this.dialogRowForm.tagId = val;
				}
				
				if (val) { //val存在
					let sameFlag = false;
					this.unBoundTagIds = this.unBoundTagIdsCopy.filter((item) => {
						if (!sameFlag) {
							sameFlag = item.tagId.toUpperCase() == val.toUpperCase() || item.tagId.substring(item.tagId.length - 4).toUpperCase() == val.substring(val.length - 4).toUpperCase();
						}
						if (!!~item.tagId.indexOf(val) || !!~item.tagId.toUpperCase().indexOf(val.toUpperCase()) || item.tagId.substring(item.tagId.length - 4).toUpperCase() == val.substring(val.length - 4).toUpperCase()) {
							return true;
						}
					});
					if (sameFlag) {
						
						this.dialogRowForm.tagId = this.unBoundTagIds[0].tagId.toUpperCase();
						//this.$refs.rowFormTagId.blur();
						
						if (
							this.dialogForm.optionType == this.optionType.edit || 
							this.dialogForm.optionType == this.optionType.binding || 
							this.dialogForm.optionType == this.optionType.unbound
						) {
							// 查询标签用户
							this.searchTagUser(this.unBoundTagIds[0].tagId);
						}
					} else {
						if (val.length >= 16) {
							let msg;
							if (this.dialogForm.optionType == this.optionType.unbound) {
								msg = '该设备未绑定！请更换已绑定设备进行解绑操作。';
							} else if (
								this.dialogForm.optionType == this.optionType.add || 
								this.dialogForm.optionType == this.optionType.edit ||
								this.dialogForm.optionType == this.optionType.binding
							) {
								msg = '该设备未添加或已绑定！请先添加该设备或解绑该设备。';
							}
							
							this.timer_dataFilter = setTimeout(() => {
								
								this.$message({
		                            message: msg,
		                            type: 'info',
		                            showClose: true,
		                            dangerouslyUseHTMLString: true
		                        });
								
							}, 400);
						}
					}
				} else { //val为空时，还原数组
					this.unBoundTagIds = Object.assign([], this.unBoundTagIdsCopy);
					//this.dialogRowForm.tagId = tagId;
				}
			},
            /**
             * @Des 查询标签用户
             * @Auth
             * @Date 2021/6/19
             */
            searchTagUser(data){
                
                if (!this.dialogRowForm.tagId) {
                	// 下拉框 清空
					this.dataClear();
					return false;
                }
                
                if(this.dialogForm.optionType == this.optionType.unbound){
                    this.$request.postJsonRequest(ApiGpsTag.findByDidApi,{
                        did: data,
                        // projectId: this.$store.state.currentProjectId
                    }).then(result => {
                        //console.log(result)
                        if(result.code == 0){
                        	let _data = Object.assign({}, result.data);
                            let data = Object.assign({}, _data.userBaseInfo);
                            // 当前用户
                            this.dialogRowForm.userId = data.userId;
                            // 性别
                            this.dialogRowForm.sex = data.sex;
                            // 区号
                            this.dialogRowForm.phoneCode = data.phoneCode;
                            // 手机号
                            this.dialogRowForm.phone = data.phone,
                            // 姓名
                            this.dialogRowForm.userName = data.userName;
                            // 职务
                            this.dialogRowForm.duty = data.duty;
                            // 备注
                            this.dialogRowForm.remarks = data.remarks;
                            // 类型id
                            this.dialogRowForm.typeId = data.typeId;
                            // 组id
                            this.dialogRowForm.groupId = data.groupId;
                            // 组名
                            this.dialogRowForm.groupName = data.groupName;
                            // 身份证号
                            this.dialogRowForm.idCard = data.idCard;
                            // 头像
                            this.dialogRowForm.portrait = data.portrait;
                        }
                    }).catch(error => {
                        console.error('查询标签用户异常', ApiUser.findByTagIdApi, error);
                    });
                }
            },
            /**
             * @Des 查询标签
             * @Auth
             * @Date 2021/6/19
             */
            searchTag(){
            	this.unBoundTagIds = [];
            	this.unBoundTagIdsCopy = [];
            	// ApiOam.Find_Uwb_Tag_By_Binding_Type_Uri
                this.$request.postJsonRequest(ApiGpsTag.fingByBindTypeApi,{
                    bindType: ((this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding')?0:1),
                    // projectId: this.$store.state.currentProjectId
                }).then(result => {
                	let unBoundTagIds = [];
                	Object.assign([], result.data).forEach((row, index) => {
                		if ((this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding') && row.bindType == 0) {
                			unBoundTagIds.push(Object.assign({}, row));
                		} else if (!(this.dialogForm.optionType=='add'||this.dialogForm.optionType=='binding') && row.bindType == 1) {
                			unBoundTagIds.push(Object.assign({}, row));
                		}
                	});
                	
                	this.unBoundTagIds = Object.assign([], unBoundTagIds);
                	// 未绑定的标签 Copy
                	this.unBoundTagIdsCopy = Object.assign([], unBoundTagIds);
                }).catch(error => {
                    console.error('查询标签异常', ApiGpsTag.fingByBindTypeApi, error);
                });
            },
			
			// ======================================== 扫码回调 start ======================================== \\
			/**
			 * @Des 扫码 跳过
			 * @Auth
			 * @Date
			 */
			skipScan() {
				// 关闭扫码
				// 是否展示
				this.scanFilter.showFlag = false;
				// tagId 下拉框不可选择
				this.dialogForm.tagIdDisabledFlag = false;
				
				if (this.dialogForm.optionType != this.optionType.binding && this.dialogForm.optionType != this.optionType.add) {
					// 重置表单
	                this.reset();
				}
                
                // 更新标签数据
                this.searchTag();
			},
			
			/**
			 * @Des 扫码 标签改变
			 * @Auth
			 * @Date
			 */
			tagChange(val) {
				// 空值 中止
				if (this.$checkEmpty(val)) return false;
				
				this.$request.postJsonRequest(ApiOam.Find_Uwb_Tag_By_TagId_Uri,{
					tagId: val,
					//projectId: this.$store.state.currentProjectId
				}).then(result => {
					if(result.code == 0){
						// 解析 标签信息
						this.analysisTagInfo(val, Object.assign({}, result.data));
					}
				}).catch(error => {
					console.error('查询标签信息异常', ApiOam.Find_Uwb_Tag_By_TagId_Uri, error);
				});
			},
			/**
			 * @Des 解析 标签信息
			 * @Auth
			 * @Date
			 */
			analysisTagInfo(val, tagInfo) {
				console.log(tagInfo);
				// 空值
				if (this.$checkEmpty(tagInfo)) {
					//  || this.$checkEmpty(tagInfo.projectId)
					// 未添加
					
					this.$confirm('标签【'+ val +'】尚未加入系统！<br>是否将该标签加入系统？', '提示', {
						closeOnClickModal : false,
						dangerouslyUseHTMLString: true,
						type: 'warning',
						confirmButtonText: '加入系统',
						cancelButtonText: '重新输入',
					}).then(_ => {
						
						// 加入系统
						this.$request.postJsonRequest(ApiOam.Add_Uwb_Tag_Id_Uri,{
							tagId: val,
							// projectId: this.$store.state.currentProjectId
						}).then(result => {
							if(result.code == 0){
								this.$message({
	                                message: '标签【'+ val +'】加入系统成功！',
	                                type: 'success',
	                                showClose: true,
	                                dangerouslyUseHTMLString: true
	                            });
								
								// 关闭扫码
								// 是否展示
								this.scanFilter.showFlag = false;
								
								// 新增人员
								this.openDialog('新增人员', '保存添加', 'add');
								// 延迟执行
								this.$nextTick(() => {
									// 默认选中标签
									this.dialogRowForm.tagId = val;
								});
								
							}
						}).catch(error => {
							console.error('新增标签异常', ApiOam.Add_Uwb_Tag_Id_Uri, error);
						});
						
					}).catch(_ => {
						
					});
				} 
				/*else if (this.$store.state.currentProjectId && tagInfo.projectId != this.$store.state.currentProjectId) {
					// 在其他项目
					
					this.$alert('标签【'+ val +'】已应用于其他项目！<br>请更换标签。', '提示', {
						type: 'warning',
						confirmButtonText: '确定',
						dangerouslyUseHTMLString: true,
						callback: action => {
							
						},
					});
					
				} */
				else if (tagInfo.bindType == 0) {
					// 未绑定 --> 新增人员
					
					// 关闭扫码
					// 是否展示
					this.scanFilter.showFlag = false;
					
					// 新增人员
					this.openDialog('新增人员', '保存添加', 'add');
					// 延迟执行
					this.$nextTick(() => {
						// 默认选中标签
						this.dialogRowForm.tagId = val;
					});
					
				} else {
					// 已绑定 --> 解绑
					
					// 关闭扫码
					// 是否展示
					this.scanFilter.showFlag = false;
					
					// 解绑标签
					this.openDialog('解绑标签','解绑标签', 'unbound');
					// 延迟执行
					this.$nextTick(() => {
						// 默认选中标签
						this.dialogRowForm.tagId = val;
						// 回显 标签信息
						this.searchTagUser(this.dialogRowForm.tagId);
					});
					
				}
			},
			// ======================================== 扫码回调 end ======================================== \\
			
            /**
             * @Des 打开账户弹窗
             * @Auth
             * @Date 2021/6/19
             */
            openDialog(title, button, optionType, data, rowIndex) {
                // console.log(data);
                this.dialogForm.dialogFormVisible = true;
                this.dialogForm.title = title;
                this.dialogForm.submitButton = button;
                this.dialogForm.optionType = optionType;
				
				// 是否展示 跳过
				this.scanFilter.skipScanFlag = true;
				// 编辑 不展示扫码
				if (optionType == this.optionType.edit) {
					// 是否展示 扫码
					this.scanFilter.showFlag = false;
				}
				
                // 重置表单
                this.reset();
                // console.log(optionType);
                if(optionType == this.optionType.add){
                    // 新增
                    this.$nextTick(function () {
                        if(data && !this.$checkEmpty(data)){
                            // this.dialogRowForm.typeId = data.parentId.replace("T","");
                            this.dialogRowForm.groupId = data.id;
                            this.dialogRowForm.groupName = data.name;
                            this.$refs['treeSelect'].setSelectVal(data);
                        }
                        this.searchTag();
                    });
                }else if(optionType == this.optionType.edit || optionType == this.optionType.binding){
                    // 编辑 或 绑定
                    this.$nextTick(function () {
                        // 当前用户
                        this.dialogRowForm.userId = data.userId;
                        // row 下标
                        this.dialogRowForm.rowIndex = rowIndex;
                        // 性别
                        this.dialogRowForm.sex = data.sex;
                        // 区号
                        this.dialogRowForm.phoneCode = data.phoneCode;
                        // 手机号
                        this.dialogRowForm.phone = data.phone;
                        // 姓名
                        this.dialogRowForm.userName = data.userName;
                        // 职务
                        this.dialogRowForm.duty = data.duty;
                        // 备注
                        this.dialogRowForm.remarks = data.remarks;
                        // 类型id
                        this.dialogRowForm.typeId = data.typeId;
                        // 组id
                        this.dialogRowForm.groupId = data.groupId;
                        // 组名
                        this.dialogRowForm.groupName = data.groupName;
                        // 身份证号
                        this.dialogRowForm.idCard = data.idCard;
                        // 头像
                        this.dialogRowForm.portrait = data.portrait;
                        // 标签id
                        this.dialogRowForm.tagId = data.tagId;
                        // 判断是绑定，还是编辑页面
                        if(optionType == 'binding'){
                            // 绑定
                            this.searchTag();
                        }else{
                            // 编辑
                            let tree = {};
                            tree.id = data.groupId;
                            tree.pid = data.typeId + "T";
                            tree.label = data.groupName;
                            this.$refs['treeSelect'].setSelectVal(tree);
                        }
                    });

                }else if(optionType == this.optionType.unbound){
                    // 解绑
                    this.searchTag();
                }
            },
            /**
             * @Des 选择值设置
             * @Auth
             * @Date 2021/6/19
             */
            setSelectVal(val){
                if(val && val.id){
                    if(val.parentId == 0){
                        this.dialogRowForm.typeId = '';
                        this.dialogRowForm.groupId = '';
                        this.dialogRowForm.groupName = '';
                        this.$refs['treeSelect'].setSelectVal();
                    }else{
                        // this.dialogRowForm.typeId = val.parentId.replace("T","");
                        this.dialogRowForm.groupId = val.id;
                        this.dialogRowForm.groupName = val.name;
                        this.$refs['treeSelect'].setSelectVal(val);
                    }
                }else{
                    this.dialogRowForm.typeId = '';
                    this.dialogRowForm.groupId = '';
                    this.dialogRowForm.groupName = '';
                    this.$refs['treeSelect'].setSelectVal();
                }
            },

            /**
             * @Des 提交账户信息
             * @Auth
             * @Date 2021/6/19
             */
            submitForm(){
                /**
                * @Des 表单校验
                * @Auth
                * @Date 2021/6/19
                */
                this.$refs.dialogRowForm.validate(valid => {
                    if(!valid) return false;
					
                    if(this.dialogForm.optionType == this.optionType.binding && this.$checkEmpty(this.dialogRowForm.tagId)){
                        this.$message({
                            message: "请确认要绑定的标签",
                            type: 'error',
                            showClose: true,
                            dangerouslyUseHTMLString: true
                        });
                        return false;
                    }
                    
                    this.dialogRowForm.portrait = this.dialogRowForm.portrait || this.defaultIcons.iconData;
                    // 交互参数
                    let params = {
                        typeId: this.dialogRowForm.typeId,
                        groupId: this.dialogRowForm.groupId,
                        groupName: this.dialogRowForm.groupName,
                    	userId: this.dialogRowForm.userId,
                        userName: this.dialogRowForm.userName,
                        sex: this.dialogRowForm.sex,
                        phoneCode: this.dialogRowForm.phoneCode,
                        phone: this.dialogRowForm.phone,
                        idCard: this.dialogRowForm.idCard,
                        portrait: this.dialogRowForm.portrait,
                        duty: this.dialogRowForm.duty,
                        tagId: this.dialogRowForm.tagId,
		                remarks: this.dialogRowForm.remarks,
                        // projectId: this.$store.state.currentProjectId,
                        userIds: [this.dialogRowForm.userId]
                    };

                    // 交互 路径
                    let submitApi = '';
                    let successMsg = '';
                    if(this.dialogForm.optionType == this.optionType.add){
                        submitApi = ApiUser.addUserApi;
                        successMsg = '添加成功！';

                    }else if(this.dialogForm.optionType == this.optionType.edit){
                        submitApi = ApiUser.updateUserApi;
                        successMsg = '编辑成功！';

                    }else if(this.dialogForm.optionType == this.optionType.binding){
                        submitApi = ApiUser.bindingUserApi;
                        successMsg = '绑定成功！';

                    }else if(this.dialogForm.optionType == this.optionType.unbound){
                        submitApi = ApiUser.unboundUserApi;
                        successMsg = '解绑成功！';
                    }


                    /**
                    * @Des 数据交互
                    * @Auth
                    * @Date 2021/6/19
                    */
                    this.$request.postJsonRequest(submitApi, params).then(result => {
                        if(result.code == 0){
                            this.$message({
                                message: successMsg,
                                type: 'success',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                            if(this.dialogForm.editFlag){
                                // 刷新列表
                                this.$emit("setRow", this.dialogRowForm, this.dialogRowForm.rowIndex);
                            }else{
                                // 添加成功
                                this.$emit("setTotal", 0);
                            }
                            // 关闭摄像头
                            this.stopNavigator();
                            
                            // 编辑 关闭弹窗
                            if (this.dialogForm.optionType == this.optionType.edit) {
                            	// 关闭弹窗
                            	this.dialogForm.dialogFormVisible = false;
                            }
                            
                        }else{
                            this.$message({
                                message: result.msg,
                                type: 'error',
                                showClose: true,
                                dangerouslyUseHTMLString: true
                            });
                        }
                        
                        // 是否展示 扫码
                        this.scanFilter.showFlag = true;
                        // tagId 下拉框不可选择
                        this.dialogForm.tagIdDisabledFlag = true;
                        
                    }).catch(error => {
                        console.error('操作标签异常', submitApi, error);
                    })
                });// validata
            },

            /**
	         * @Des 关闭弹窗
	         * @Auth
	         * @Date 2021/6/19
	         */
	        handleDialogClose(){
                // 是否展示 扫码
                this.scanFilter.showFlag = true;
                // tagId 下拉框不可选择
                this.dialogForm.tagIdDisabledFlag = true;
                // 关闭摄像头
                this.stopNavigator();
	        },

            /**
	         * @Des 重置方法
	         * @Auth Zhangbin
	         * @Date 17:28 2021/4/30
	         */
	        reset(){
	            // 清除表单数据
	            this.cleanData(this.dialogRowForm)
	            // 清除表单验证
	            this.cleanValidate('dialogRowForm');
	        },

            /**
             * @Des 清除验证信息
             * @Auth
             * @Date 2021/6/19
             */
            cleanValidate(formName){
                // 清除表单校验的提示
                if (this.$refs[formName]) {
                    // 延时执行
                    this.$nextTick(function () {
                        this.$refs[formName].clearValidate();
                    })
                };
            },
            /**
	         * @Des 清除数据
	         * @Auth
	         * @Date 2021/6/19
	         */
	        cleanData(form){
	            // 延时执行
	            this.$nextTick(() => {
                    // 当前用户
                    form.userId = '';
                    // row 下标
                    form.rowIndex = -1;
                    // 性别
                    form.sex = 1;
                    // 区号
                    form.phoneCode = 86;
                    // 手机号
                    form.phone = '';
                    // 姓名
                    form.userName = '';
                    // 职务
                    form.duty = '';
                    // 备注
                    form.remarks = '';
                    // 类型id
                    form.typeId = '';
                    // 组id
                    form.groupId = '';
                    // 组名
                    form.groupName = '';
                    // 身份证号
                    form.idCard = '';
                    // 头像
                    form.portrait = '';
                    // 标签id
                    form.tagId = '';
	            });// 延时执行
	        },
			
        },// methods
        // 计算属性
        computed: {
        	// 获取 imgdata
			extractImgData: function () {
				let portrait = this.dialogRowForm.portrait;
				
				// 有值 返回当前值
				if (!this.$checkEmpty(portrait)) return portrait;
				
				let _this = this;
				// img url 转 base64
				GlobalFun.base64Image(this.defaultIcons[this.dialogRowForm.sex], data => {
					_this.defaultIcons.iconData = data;
				});
				return portrait || this.defaultIcons.iconData;// this.defaultIcons[this.dialogRowForm.sex];//
			}
        },
    }
</script>

/* CSS */
<style lang="scss" scoped>
	/deep/ .el-dialog {
		width: 1200px;
		max-width: 90%;
	}
	/deep/ .el-dialog__body {
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/components_pages/User/UserDialog.vue